import { defineCustomElements } from '@ford-fusion/webcomponents/loader';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';

registerLocaleData(localePtBr);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);

defineCustomElements(globalThis as typeof globalThis & Window);
